import {
  useFetchZoneCategoriesQuery,
  useFetchBuildingZoneCategoriesQuery,
  useFetchZoneCategoryServiceItemsQuery,
  ZoneCategory,
} from 'store/apis';
import { selectCurrentUserInfo } from 'store/slices/auth.slice';
import { useAppSelector } from 'store/store.hook';
import { capitalizeFirstLetter } from 'utils';

type GetZoneCategoryDetailsPayload = {
  zoneCategory: ZoneCategory & { id: number };
};

const getZoneCategoryDetails = ({ zoneCategory }: GetZoneCategoryDetailsPayload) => {
  const { category, target_interval, target_frequency } = zoneCategory;

  const title = category;
  const interval = capitalizeFirstLetter(target_interval);
  const frequency = target_frequency;

  return { ...zoneCategory, title, interval, frequency };
};

export const useZoneCategories = () => {
  const { orgSlug } = useAppSelector(selectCurrentUserInfo);

  const { data = [], ...rest } = useFetchZoneCategoriesQuery({ orgSlug });

  const zoneCategories = data.map((zoneCategory) => getZoneCategoryDetails({ zoneCategory }));

  return { data: zoneCategories, ...rest };
};

type UseBuildingZoneCategoriesProps = {
  buildingId: number;
};

export const useBuildingZoneCategories = ({ buildingId }: UseBuildingZoneCategoriesProps) => {
  const { orgSlug } = useAppSelector(selectCurrentUserInfo);

  const { data = [], ...rest } = useFetchBuildingZoneCategoriesQuery({ orgSlug, buildingId });

  return { data, ...rest };
};

type UseZoneCategoryServiceItemsProps = {
  categoryId: number | null | undefined;
};

export const useZoneCategoryServiceItems = ({ categoryId }: UseZoneCategoryServiceItemsProps) => {
  const { orgSlug } = useAppSelector(selectCurrentUserInfo);
  const shouldSkip = categoryId == null;

  const { data = [], ...rest } = useFetchZoneCategoryServiceItemsQuery(
    { orgSlug, categoryId: categoryId ?? 0 },
    { skip: shouldSkip },
  );

  return { data, ...rest };
};
